import Modal from 'components/Modal';

import styles from './NoteForWorkerModal.module.scss';
import Typography from 'components/Typography';
import {useEffect, useState} from 'react';
import Button from 'components/Button';
import {Order} from 'types';
import api from 'api';
import toast from 'react-hot-toast';
import {get} from 'lodash';

type NoteForWorkerModalProps = {
  isOpen: boolean;
  onClose: () => void;
  order: Order;
  refetch: () => void;
};

function NoteForWorkerModal({
  isOpen,
  onClose,
  order,
  refetch,
}: NoteForWorkerModalProps) {
  const [note, setNote] = useState<string>('');
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    if (isOpen && !!order) {
      setNote(get(order, 'staff_note', '') as string);
    }
  }, [order, isOpen]);
  async function sendDriverNote() {
    try {
      setIsLoading(true);
      await api.post(`/routes/deliveries/staff_note/${order.id}/`, {
        staff_note: note,
      });
      toast.success('Note saved successfully');
      setNote('');
      refetch();
    } catch (error) {
      toast.error(
        get(error, 'response.data.detail', '') || 'Failed to send note'
      );
    } finally {
      setIsLoading(false);
      onClose();
    }
  }
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      onRequestClose={onClose}
      className={styles.modal}
    >
      <div className={styles.modalContent}>
        <Typography variant="h2">Note for Worker</Typography>
        <textarea
          className={styles.textarea}
          placeholder="Enter your note here"
          rows={4}
          value={note}
          onChange={(e) => setNote(e.target.value as string)}
        />
      </div>
      <div className={styles.buttonContainer}>
        <Button
          color="primary"
          onClick={sendDriverNote}
          disabled={!note}
          loading={isLoading}
        >
          Save Note
        </Button>
      </div>
    </Modal>
  );
}
export default NoteForWorkerModal;
